<div class="details-2-container">
    <h2
        nxHeadline="section"
        class="section-title"
    >
        {{'details2.title' | translate}}
    </h2>
    <form
        id="object-details-2"
        [formGroup]="parentForm"
        style="margin-bottom: 20px;"
    >
        <qbe-panel-component>
            <div
            nxRow
            class="inner-element outer-element"
        >
            <div
                nxCol="12, 12, 7"
                class="inner-element-left block"
            >
                <input
                    type="text"
                    type="hidden"
                    formControlName="errorControl"
                >
                <div class="inner-element-title">{{'details2.contactDetails' | translate}}</div>
                <div class="inner-element-consent-secondary">
                    {{'details2.conact-details-consent-part1' | translate}}
                </div>
                    <div class="inner-element-consent-secondary">
                    {{'details2.conact-details-consent-part2' | translate}}                  
                </div>
            </div>
            <div
                nxCol="12, 12, 5"
                class="inner-element-right"
            >
                <nx-formfield
                    label="{{'details2.name' | translate}}"
                    class="inner-element-right-item"
                    style="margin-bottom: 32px;"
                >
                    <input
                        nxInput
                        formControlName="firstFirstName"
                        pattern="[а-яА-ЯЁё]*"
                        (change)="this.proposalService.setInsurerFirstName( parentForm.controls.firstFirstName._pendingValue)"
                        (change)="this.trackService.checkErrors( parentForm.controls.firstFirstName, 'User first name')" 

                    >
                    <nx-error
                    class="field-error"
                    nxFormfieldError
                    appearance="text"
                >
                    {{'error.errorName' | translate}}
                    </nx-error>
                </nx-formfield>
<!--                
                <nx-formfield
                >
                <nx-dropdown
                [showFilter]="true"
                class="phone-code"
                formControlName="firstCountryCode"
              >
                <nx-dropdown-item
                  *ngFor="let item of phoneCodes"
                  [value]="'+' + item"
                  (click)="setMobileCode(item)"
                  (click)="this.trackService.pushEventTracking('user.mobilePhone', parentForm.controls.firstCountryCode.value+ parentForm.controls.firstPhoneNumber.value)"
                >
                  {{ "+" + item }}
                </nx-dropdown-item>
              </nx-dropdown>
              <input
                class="input-padding"
                [deactivateMask]="deactivateMask"
                [nxMask]="phoneMask"
                maxlength='15'
                [separators]="phoneSeparator"
                placeholder = "{{ 'details2.mobilePhone' | translate }}"
                [dropSpecialCharacters]="true"
                nxInput
                required
                [pattern]="phonePattern"
                formControlName="firstPhoneNumber"
                (blur)="this.trackService.pushEventTracking('user.mobilePhone', parentForm.controls.firstCountryCode.value+ parentForm.controls.firstPhoneNumber.value)"
                (blur)="this.trackService.checkErrors( parentForm.controls.firstPhoneNumber, 'User mobile number')" 

              />

              <span nxFormfieldHint>+359 88 488 76хх</span>
                </nx-formfield>
                
                <nx-error *ngIf="(parentForm.get('firstPhoneNumber').errors && this.parentForm.get('firstPhoneNumber').value!==null) || (this.parentForm.get('firstPhoneNumber').value===null && this.parentForm.get('firstPhoneNumber').touched===true) || this.parentForm.get('firstPhoneNumber').value===''"
              class="field-error"
              appearance="text"
             >
              {{'error.errorMessage' | translate}}
             </nx-error> -->


             <nx-formfield>
                <app-phone-numbers [mobilePhone]="firstPhoneNumber" [mobileCode]="firstCountryCode" trackingPath="user.mobilePhone" >
                </app-phone-numbers>
                <span nxFormfieldHint>+35988 488 76xx</span>
    
            </nx-formfield>
               
            </div>
        </div>

            <div
                nxRow
                class="inner-element"
            >
                <div
                    nxCol="12, 12, 7"
                    class="inner-element-left"
                >
                    <input
                        type="text"
                        type="hidden"
                        formControlName="errorControl"
                    >
                    <div class="inner-element-left-title">{{'details2.propertyArea' | translate}}</div>
                </div>
                <div
                    nxCol="12, 12, 5"
                    class="inner-element-right"
                >
                    <nx-formfield
                        [label]="'details2.area' | translate"
                        class="inner-element-right-item"
                    >
                        <input
                            nxInput
                            formControlName="area"
                            type="text"
                            (blur)="setDigitalDataArea(parentForm.controls.yearOfConstruction.value)"
                            inputmode="numeric"
                            pattern="^\d{1,3}?$"
                            maxlength="3"
                            digitOnly
                            (change)="setArea()"
                            (change)="trackService.addAttribute('propertyDetails.squareMeters',parentForm.controls.area.value)"
                            (change)="this.trackService.checkErrors(parentForm.controls.area, 'Property area')" 

                        >
                        <span nxFormfieldHint>89m²</span>
                        <span>m²</span>
                    </nx-formfield>
                </div>
            </div>
            <div
                nxRow
                class="inner-element"
                *ngIf="parentForm.controls.propertyCategory.value === '1' || parentForm.controls.propertyCategory.value === '3'"
            >
                <div
                    nxCol="12, 12, 7"
                    class="inner-element-left"
                >
                    <div class="inner-element-left-title">
                        {{'details2.immovablePropertyValue' | translate}}
                    </div>
                </div>
                <div
                    nxCol="12, 12, 5"
                    class="inner-element-right"
                >
                    <nx-formfield
                        [label]="'details2.immovableValue' | translate"
                        class="inner-element-right-item"
                        [ngClass]="{'has-error': parentForm.controls.immovableinsuranceSumRecommended?.errors?.invalid}"
                    >
                        <input
                            nxInput
                            [ngValue]="valueMovable"
                            formControlName="immovableinsuranceSumRecommended"
                            mask="separator.2"
                            (keyup.enter)="setCheckbox(!(parentForm.controls.immovableinsuranceSumRecommended.value && parentForm.controls.immovableinsuranceSumRecommended.valid), 'immovableinsuranceSumRecommended', 'movableinsuranceCheckbox', 'immovableinsuranceCheckbox', $event)"
                            (blur)="setCheckbox(!(parentForm.controls.immovableinsuranceSumRecommended.value && parentForm.controls.immovableinsuranceSumRecommended.valid), 'immovableinsuranceSumRecommended', 'movableinsuranceCheckbox', 'immovableinsuranceCheckbox', $event)"
                            (change)="trackService.addAttribute('propertyDetails.immovableinsuranceSumRecommended',parentForm.controls.immovableinsuranceSumRecommended.value)"
                            (change)="this.trackService.checkErrors(parentForm.controls.immovableinsuranceSumRecommended, 'Recommended sum')" 

                        >
                        <span
                            *ngIf="parentForm.controls.immovableinsuranceSumRecommended.value"
                            nxFormfieldHint
                        >
                            {{ 'details2.immovableLimit' | translate:{value: immovableinsuranceSumRecommended  | mask: 'separator.2'} }} {{(sharedService.getCurrency() | async).main | translate}}
                        </span>
                        <span>{{(sharedService.getCurrency() | async).main | translate}}</span>
                    </nx-formfield>
                    <nx-checkbox
                        formControlName="immovableinsuranceCheckbox"
                        (checkedChange)="onCheckedChange($event, 'immovableinsuranceSumRecommended', 'movableinsuranceCheckbox')"
                        [ngClass]="{'checkbox': true, 'top16': !parentForm.controls.immovableinsuranceSumRecommended.value}"
                        disabled="false"
                    >
                        {{ 'details2.buttonEdit' | translate:{value: parentForm.controls.immovableinsuranceSum.value} }}
                    </nx-checkbox>
                    <nx-message-banner
                        *ngIf="parentForm.controls.immovableinsuranceSumRecommended?.errors?.invalid"
                        nxFormfieldError
                        appCloseBanner="immovableinsuranceSumRecommended"
                        context="error"
                        closeButtonLabel="error.close | translate"
                    >
                        {{parentForm.controls.immovableinsuranceSumRecommended?.errors?.invalid}}
                    </nx-message-banner>
                </div>
            </div>
            <div
                nxRow
                class="inner-element"
                *ngIf="parentForm.controls.propertyCategory.value === '2' || parentForm.controls.propertyCategory.value === '1'"
            >
                <div
                    nxCol="12, 12, 7"
                    class="inner-element-left"
                >
                    <div class="inner-element-left-title">
                        {{'details2.movablePropertyValue' | translate}}
                    </div>
                </div>
                <div
                    nxCol="12, 12, 5"
                    class="inner-element-right"
                >
                    <nx-formfield
                        [label]="'details2.immovableValue' | translate"
                        class="inner-element-right-item"
                        [ngClass]="{'has-error': parentForm.controls.movableinsuranceSumRecommended?.errors?.invalid}"
                    >
                        <input
                            nxInput
                            [ngValue]="valueImmovable"
                            formControlName="movableinsuranceSumRecommended"
                            mask="separator.2"
                            (change)="trackService.addAttribute('propertyDetails.movableinsuranceSumRecommended',parentForm.controls.movableinsuranceSumRecommended.value)"
                            (blur)="setCheckbox(!(parentForm.controls.movableinsuranceSumRecommended.value && parentForm.controls.movableinsuranceSumRecommended.valid), 'movableinsuranceSumRecommended', 'immovableinsuranceCheckbox', 'movableinsuranceCheckbox', $event)"
                            (keyup.enter)="setCheckbox(!(parentForm.controls.movableinsuranceSumRecommended.value && parentForm.controls.movableinsuranceSumRecommended.valid), 'movableinsuranceSumRecommended', 'immovableinsuranceCheckbox', 'movableinsuranceCheckbox', $event)"
                            (change)="this.trackService.checkErrors(parentForm.controls.movableinsuranceSumRecommended, 'Recommended sum')" 

                        >
                        <span
                            *ngIf="parentForm.controls.propertyCategory.value === '1'"
                            nxFormfieldHint
                        >
                            <!-- {{'details2.movableLimit' | translate: {
                        minValue: parentForm.controls.movableinsuranceSum.value  | mask: 'separator.2',
                        maxValue: movableinsuranceSumRecommended  | mask: 'separator.2'
                        }
                        }} {{(sharedService.getCurrency() | async).main | translate}} -->
                        
                        {{parentForm.controls.movableinsuranceSum.value  | mask: 'separator.2' }} {{(sharedService.getCurrency() | async).main | translate}} - 
                        {{movableinsuranceSumRecommended  | mask: 'separator.2' }}
                        {{(sharedService.getCurrency() | async).main | translate}}

                        </span>
                        <span
                            *ngIf="parentForm.controls.propertyCategory.value === '2'"
                            nxFormfieldHint
                        >
                        
                            {{'details2.movableLimitSingle' | translate: {
                        minValue: parentForm.controls.movableinsuranceSum.value  | mask: 'separator.2'}
                        }} {{(sharedService.getCurrency() | async).main | translate}}
                        </span>
                        <span>{{(sharedService.getCurrency() | async).main | translate}}</span>
                    </nx-formfield>
                    <nx-checkbox
                        formControlName="movableinsuranceCheckbox"
                        (checkedChange)="onCheckedChange($event, 'movableinsuranceSumRecommended', 'immovableinsuranceCheckbox')"
                        class="checkbox"
                        disabled="false"
                    >
                        {{ 'details2.buttonEdit' | translate }}
                    </nx-checkbox>
                    <nx-message-banner
                        *ngIf="parentForm.controls.movableinsuranceSumRecommended?.errors?.invalid"
                        nxFormfieldError
                        appCloseBanner="movableinsuranceSum"
                        context="error"
                        closeButtonLabel="error.close | translate"
                    >
                        {{parentForm.controls.movableinsuranceSumRecommended?.errors?.invalid}}
                    </nx-message-banner>
                </div>
            </div>


            <div
                nxRow
                class="inner-element"
            >
                <div
                    nxCol="12, 12, 7"
                    class="inner-element-left"
                >
                    <div class="inner-element-left-title">
                        {{'details2.propertyClaims' | translate}}
                    </div>
                </div>
                <div
                    nxCol="12, 12, 5"
                    class="inner-element-right align-center buttonsContainer"
                >
                    <input
                        type="radio"
                        [value]="true"
                        formControlName="claimsExists"
                    >
                    <qbe-button
                        mode="secondary"
                        class="yesno-button mobifix-details3"
                    >
                        <label>
                            {{'common.yes' | translate}}
                            <input
                                type="radio"
                                [value]="true"
                                formControlName="claimsExists"
                                (click)="trackService.addAttribute('propertyDetails.claimsRegistared', 'Yes')"
                            >
                        </label>
                    </qbe-button>
                    <input
                        type="radio"
                        [value]="false"
                        formControlName="claimsExists"
                    >
                    <qbe-button
                        mode="secondary"
                        class="yesno-button"
                    >
                        <label>
                            {{'common.no' | translate}}
                            <input
                                type="radio"
                                [value]="false"
                                formControlName="claimsExists"
                                (click)="trackService.addAttribute('propertyDetails.claimsRegistared', 'No')"
                            >
                        </label>
                    </qbe-button>
                </div>
            </div>


            <!-- <div
                nxRow
                class="inner-element"
            >
                <div
                    nxCol="12, 12, 7"
                    class="inner-element-left block"
                >
                    <div class="inner-element-title">{{'details2.phoneNumber' | translate}}</div>
                    <div *ngIf="trigger == false">
                        <div class="inner-element-consent">{{'details2.phoneConsent' | translate}}</div>
                        <div class="lower-border-button">
                            <button
                                nxPlainButton
                                type="button"
                                (click)="readMore()"
                            >
                                <nx-icon
                                    name="chevron-down"
                                    class="nx-margin-right-xs fileTextIcon"
                                ></nx-icon>
                                <span class="readMore">{{"details2.readmore" | translate}}</span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="trigger == true">
                        <div class="inner-element-consent-secondary">{{'details2.phoneConsent' | translate}}</div>
                        <div class="lower-border-button">
                            <button
                                nxPlainButton
                                type="button"
                                (click)="readMore()"
                            >
                                <nx-icon
                                    name="chevron-up"
                                    class="nx-margin-right-xs fileTextIcon"
                                ></nx-icon>
                                <span class="readMore">{{'details2.readless' | translate}}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    nxCol="12, 12, 5"
                    class="inner-element-right"
                >
                    <nx-formfield label="{{'details2.mobilePhone' | translate}}">
                        <input
                            nxInput
                            formControlName="firstPhoneNumber"
                            pattern="[+][3]{1}[5]{1}[9]{1}[1-9]{1}[0-9]{8}$"
                            (change)="trackService.addAttribute('insurances.mobilePhone', parentForm.controls.firstPhoneNumber.value)"
                        >
                        <span nxFormfieldHint>+359887504962</span>
                        <nx-error
                            class="field-error"
                            nxFormfieldError
                            appearance="text"
                        >
                            {{'error.errorMessage' | translate}}
                        </nx-error>


                    </nx-formfield>
                </div>
            </div> -->
        </qbe-panel-component>
    </form>
    <div class="error-message-address">
        <nx-message-banner
                *ngIf="sharedService.errorMessageDifferentPostCodeReturned$ | async"
                context="info"
                closable="true"
                (close)="sharedService.errorMessageDifferentPostCodeReturned$.next(false)"
                class="nx-margin-bottom-xs"
        >

            {{ 'details1.errorMessageDifferentPostCodeReturned' | translate: { 
            newPostCode: this.formService.currentForm.get('postCode').value
        }  }}
        </nx-message-banner>
    </div>
    </div>
